import marked from 'marked';

export default {
    methods: {
        markdown(string) {
            return marked(string);
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/markdown.js